import { HtmlCssPageComponent, PageComponent } from 'types';
import { useEffect, useRef } from 'react';
import styles from '../../styles/components/page-components/html-css.module.scss';

export default function HtmlCssComponent(
  props: PageComponent<HtmlCssPageComponent>
) {
  const { html, css } = props.data;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      // Apply the custom CSS
      const styleEl = document.createElement('style');
      styleEl.textContent = css;
      containerRef.current.appendChild(styleEl);

      // Set the HTML content
      const contentEl = document.createElement('div');
      contentEl.className = styles.htmlContent;
      contentEl.innerHTML = html;
      containerRef.current.appendChild(contentEl);

      return () => {
        // Cleanup
        if (containerRef.current) {
          containerRef.current.removeChild(styleEl);
          containerRef.current.removeChild(contentEl);
        }
      };
    }
  }, [html, css]);

  return <div className={styles.container} ref={containerRef}></div>;
}
